// extracted by mini-css-extract-plugin
export default {"upload_file":"file_upload_file__NbI8F","error":"file_error__SmbYU","upload_link":"file_upload_link__LIOjO","formats_text":"file_formats_text__iDRpJ"};